import React, { useEffect, useState } from 'react';
import ReactDOM from "react-dom/client";
import { DataGrid } from 'devextreme-react';
import { Box } from '@mui/material';
import { PricelistApis } from 'hooks/apis/PricelistApis';
import { IAnalyteDetail } from 'interfaces/Pricelist/IAnalyteDetail';
import { IPricelistMasterDetailProps } from 'interfaces/Pricelist/IPricelistMasterDetailProps';

const AnalyteInfo = (props: IPricelistMasterDetailProps) => {
  const { getAnalyteInfo } = PricelistApis();
  const [error, setError] = useState('');
  const [loadingInfo, setLoadingInfo] = useState<boolean>(true);
  const [analyteInfo, setAnalyteInfo] = useState<IAnalyteDetail | undefined>();

  useEffect(() => {
    getAnalyteInfo(props.analysis, props.matrix)
      .then((data) => {
        if (data?.message) {
          setError(data?.message);
        } else {
          setAnalyteInfo(data);
        }
      })
      .catch((e) => setError(e))
      .finally(() => setLoadingInfo(false));
  }, [props, getAnalyteInfo]);

  return (
    <Box className="analyteInfo">
      {error ? <Box className="errorBox">{error}</Box> : null}
      {!error && loadingInfo ? <Box className="loadingBox">Loading Analyte Info...</Box> : null}
      {!error && !loadingInfo && analyteInfo?.AnalyteList?.length === 0 ? <Box className="loadingBox">No analytes available</Box> : null}
      {!error && !loadingInfo && analyteInfo?.AnalyteList?.length > 0 ?
      <DataGrid
        dataSource={analyteInfo.AnalyteList}
        rowAlternationEnabled={true}
        showBorders={false}
        wordWrapEnabled={true}
        hoverStateEnabled={false}
        sorting={{ mode: "multiple" }}
        paging={{ enabled: false }}
        headerFilter={{ visible: false }}
        columns={[
          { dataField: "AnalyteOrder", visible: false, sortOrder: "asc", dataType: "number" },
          { dataField: "Analyte", dataType: "string" },
          { dataField: "AnalyteAliases", dataType: "string" },
          {
            allowFiltering: false,
            width: 300,
            dataField: "Comments",
            cellTemplate: (container, options) => {
              const root = ReactDOM.createRoot(container);
              root.render(<Box className="analysisComments">{options?.data?.Comments}</Box>);
            },
            dataType: "string",
          },
          { dataField: "PqlText", dataType: "string", alignment: "center", caption: `PQL(${analyteInfo.Units})`, width: 150 },
          { dataField: "NataPerth", dataType: "boolean", caption: "NATA Per", visible: analyteInfo.PerthTesting, width: 100 },
          { dataField: "NataSydney", dataType: "boolean", caption: "NATA Syd", visible: analyteInfo.SydneyTesting, width: 100 },
          { dataField: "NataMelbourne", dataType: "boolean", caption: "NATA Mel", visible: analyteInfo.MelbourneTesting, width: 100 },
          { dataField: "NataDarwin", dataType: "boolean", caption: "NATA Dar", visible: analyteInfo.DarwinTesting, width: 100 },
          { dataField: "NataNewcastle", dataType: "boolean", caption: "NATA New", visible: analyteInfo.NewcastleTesting, width: 100 },
          { dataField: "NataSubcon", dataType: "boolean", caption: "NATA Subcon", visible: analyteInfo.SubconTesting, width: 130 },
        ]}
      /> : null }
    </Box>
  );
};

export default React.memo(AnalyteInfo);
